import React, { useEffect, useState } from 'react'
import logo from "../Assets/logo.svg";
import { Link , useLocation, useNavigate} from 'react-router-dom';
import styles from '../styles';
import { FaBars } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import LanguagesDrop from './LanguagesDrop';
import { useTranslation } from 'react-i18next';
import star from '../Assets/star.png'

const Header = ({dis}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const location = useLocation();
  const navigate = useNavigate();
  const [nav , setNav] = useState(false);
  const [active , setActive] = useState(location);
  const [parentTop, setParentTop] = useState(0);
  const links = t('header.links', { returnObjects: true });

  const handleNavigation = (link) => {
    if (link === 'home' || link === 'contact' || link === 'products') {
      // Page navigation
      navigate(`/${link}`);
      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Section navigation - first go to home page then scroll
      navigate('/home', { state: { scrollTo: link } });
    }
    setActive(link);
  };

  useEffect(() => {
    // Handle section scrolling when coming from another page
    if (location.pathname === '/home' && location.state?.scrollTo) {
      const element = document.querySelector(`[name='${location.state.scrollTo}']`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (location.pathname === '/home' || location.pathname === '/contact' || location.pathname === '/products') {
      // Scroll to top when directly navigating to home or contact
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const headerElement = document.querySelector('.header_container');
      if (headerElement && headerElement.parentElement) {
        const parentRect = headerElement.parentElement.getBoundingClientRect();
        setParentTop(parentRect.top);
      }
    };

    // Initial check
    handleScroll();
    
    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Cleanup
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Map language codes to country codes for flags
  const languageToCountry = {
    fr: 'FR', // France
    en: 'US', // United States
    ar: 'MA'  // Morocco
  };

  // Get current flag based on selected language
  const getCurrentFlag = () => {
    const countryCode = languageToCountry[i18n.language] || 'FR';
    return `https://hatscripts.github.io/circle-flags/flags/${countryCode}.svg`;
    // return `https://flagsapi.com/${countryCode}/flat/64.png`;
  };

  return (
    <div className={`header_container ${isRTL? 'rtl' : 'ltr'} w-full ${isRTL ? '!font-almarai' : 'font-inter'}  py-3 justify-between ${dis ? ' px-2 sm:px-4  ' : ' '} flex items-center relative after:content-[""] after:absolute after:bg-paragraph/30 after:w-full after:h-[2px] ${dis || parentTop === 0  ? 'after:bottom-0 after:left-0' : 'after:-bottom-10'} `}>
        <div className={` ${dis ? 'w-1/2 h-full' : 'w-auto'} flex justify-start items-center`}>
          <Link to={'/home'} smooth duration={500} className={`h-[52px] xl:h-[60px]`}>
            <img loading="lazy" className={`${dis ? 'w-[90%] h-full aspect-[170/45]'  :'h-full'}`} src={logo} alt='Logo'/>
          </Link>
        </div>
        <div className={`${dis ? 'hidden' : 'flex'} justify-between items-center`}>
            <ul className='flex gap-[18px] xl:gap-[30px] xxl:gap-[48px] xxxl:gap-20' >
            {
                links.map(({id , link , name}) => (
                <li key={id} 
                    className={`${styles.headerlinks} ${(location.pathname === `/`+link || (location.pathname === '/home' && location.state?.scrollTo === link)) && 'text-primary !font-bold relative after:content-[""] after:absolute after:bg-secondary after:rounded-[9999px] after:w-full after:h-[3px] after:-bottom-3  after:left-1/2 after:-translate-x-1/2'}`} 
                    onClick={() => handleNavigation(link)}>
                    {(location.pathname === `/`+link || (location.pathname === '/home' && location.state?.scrollTo === link)) && <img src={star} alt="star" className='w-5 h-5 absolute -top-6 left-1/2 -translate-x-1/2'/>}
                    <span className="cursor-pointer">{name}</span>
                </li>
                ))
            }
            </ul>
        </div>
        <div className={`${dis ? 'block' : 'hidden'} flex gap-2 items-center`}>
          <div className='languages  flex items-center gap-2'>
            <LanguagesDrop w={20} className='bg-primary text-white' classN='text-white data-[focus]:bg-secondary data-[focus]:text-primary' classN1='bg-primary' icoclass='text-white' flagborder='border-[2px] border-solid border-white rounded-full '/>
          </div>
          <div className={` cursor-pointer z-10 flex gap-2`} onClick={() => {setNav(!nav)}}>
            {nav ? <FaTimes size={30} fill='#C10100'/> : <FaBars size={30}  fill='#C10100'/>}
          </div>
        </div>

        {nav && 
          <ul className='flex flex-col justify-center gap-16 items-center absolute top-0 left-0 w-full h-screen bg-gradient-to-b from-primary02 via-primary02 to-primary opacity-95 transform transition-all duration-500'
           >
          {
              links.map(({id , link, name}) => (
              <li key={id} 
                  className={`${styles.headerlinksmobile} flex justify-center items-center  ${(location.pathname === `/`+link || (location.pathname === '/home' && location.state?.scrollTo === link)) ? '!text-secondary !font-bold' : 'opacity-70'}`} 
                  onClick={() => {handleNavigation(link); setNav(!nav)}}>
                  <span className="cursor-pointer text-center">{name}</span>
              </li>
              ))
          }
          </ul>
        }
        <div className={`${dis ? 'hidden' : 'flex w-auto'} items-center justify-end`}>
            <button className={`${styles.primaryBotton} rounded-full`}>
                <Link to={'contact'} smooth duration={50}>{t('header.devis')}</Link>
            </button>
        </div>
    </div>
  )
}

export default Header